import { ContextsState } from '@/store';
import { ClientDate } from '@/core/helpers';
import { Channel, RelocationLimit } from '.';

export class EditedRelocationLimit {

    public static createDefault(): EditedRelocationLimit {

        const id = undefined;
        const channel = undefined;
        const volume = 0;
        const weightLimit = 0;

        const startDate = new ClientDate(ContextsState.current?.currentTime);
        const endDate = new ClientDate().onlyDate().addDay(1);

        const result = new EditedRelocationLimit(
            id,
            channel,
            startDate,
            endDate,
            volume,
            weightLimit,
        );
        return result;
    }
    public static fromRelocationLimit(relocationLimit: RelocationLimit): EditedRelocationLimit {

        const { id, channel, startDate, endDate, volume, weightLimit } = relocationLimit;
        const result = new EditedRelocationLimit(
            id, channel, startDate, endDate, volume, weightLimit
        );
        return result;
    }

    public readonly id?: string;
    public channel?: Channel;
    public startDate: ClientDate | null;
    public endDate: ClientDate | null;
    public volume: number | null;
    public weightLimit: number | null;

    constructor(
        id: string | undefined,
        channel: Channel | undefined,
        startDate: ClientDate,
        endDate: ClientDate,
        volume: number | null,
        weightLimit: number | null,
    ) {
        this.id = id;
        this.channel = channel;
        this.startDate = startDate;
        this.endDate = endDate;
        this.volume = volume;
        this.weightLimit = weightLimit;
    }
}
